/* eslint-disable jsx-a11y/control-has-associated-label */
import { defineMessages, useIntl } from 'react-intl';
import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import SvgIcon from '../SvgIcon/SvgIcon';
import scLogo from '../../images/spectrocoin_logo.svg';

import styles from './Footer.module.scss';
import { getLink } from '../../redux/FooterSlice/FooterSelectors';
import { useAppDispatch } from '../../redux/Store';
import FooterActions from '../../redux/FooterSlice/FooterActions';
import TestIds from '../../tests/TestIds';

const messages = defineMessages({
	poweredBy: {
		id: 'payments.powered_by_x',
		defaultMessage: 'Powered by {Logo}',
	},
	terms: {
		id: 'payments.terms',
		defaultMessage: 'Terms',
	},
	privacy: {
		id: 'payments.privacy',
		defaultMessage: 'Privacy',
	},
});

const TERMS_URL = 'https://spectrocoin.com/en/terms.html';
const PRIVACY_URL = 'https://spectrocoin.com/en/terms/privacy-policy-eu.html';

const Link: FC<{ text: string; link?: string }> = ({ text, link, ...attr }) => {
	return (
		<a
			className={styles.link}
			href={link}
			target="_blank"
			rel="noreferrer"
			data-cy={TestIds.FooterLink}
			{...attr}
		>
			{text}
		</a>
	);
};

const Footer: FC = () => {
	const { formatMessage } = useIntl();
	const link = useSelector(getLink);

	const dispatch = useAppDispatch();

	useEffect(
		() => () => {
			dispatch(FooterActions.setLink(null));
		},
		[dispatch]
	);

	return (
		<div className={styles.container} data-cy={TestIds.Footer}>
			{link && (
				<div className={styles.links}>
					<Link text={link.label} link={link.src} />
				</div>
			)}
			<div className={styles.logo}>
				{formatMessage(messages.poweredBy, {
					Logo: (
						<a href={window.origin}>
							<SvgIcon className={styles.icon} src={scLogo} />
						</a>
					),
				})}
			</div>
			<div className={styles.links}>
				<Link text={formatMessage(messages.terms)} link={TERMS_URL} />
				<Link text={formatMessage(messages.privacy)} link={PRIVACY_URL} />
			</div>
		</div>
	);
};

export default Footer;
